import React from 'react';
import { Container } from '@material-ui/core';
import styles from './Layout.module.scss';
export function LayoutMinimal({ children }) {
    return (React.createElement(Container, { disableGutters: true },
        React.createElement("div", { className: styles.page },
            React.createElement(Container, null,
                React.createElement("div", { "data-qa-id": "pageContent", className: styles.content }, children)))));
}
